import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import AuthActions from '../auth/actions';
import { CONSTANT_VARIABLES } from '../../views/common/Constant_Variables/constants';

function* fetchAuthorizedUsers() {
  try {
    yield put(Actions.setAuthorizedUsersLoaderStatus({ authorizedUsersLoader: true }));
    const { data } = yield call(api.get, {
      route: `authorisation`,
    });
    const authorizedUsersData = data;
    yield put(Actions.setAuthorizedUsers({ authorizedUsersData }));
    yield put(Actions.setAuthorizedUsersLoaderStatus({ authorizedUsersLoader: false }));
  } catch (err) {
    yield put(Actions.setAuthorizedUsersLoaderStatus({ authorizedUsersLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* updateUserRole({ userRole }) {
  try {
    yield call(api.put, {
      route: `authorisation`,
      data: userRole,
    });
    yield put(Actions.fetchAuthorizedUsers());
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* updateUserContactData({ userContactData, notificationSettingsParams }) {
  try {
    yield call(api.put, {
      route: `authorisation`,
      data: userContactData,
    });
    notification('success', CONSTANT_VARIABLES.CONTACT_DETAILS_UPDATED, '');
    yield put(AuthActions.getUserAuthData());
    yield put(Actions.fetchUserNotifications({ notificationSettingsParams }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* fetchUserRoles() {
  try {
    const { data } = yield call(api.get, {
      route: `Roles/getroles`,
    });
    const userRolesData = data;
    yield put(Actions.setUserRoles({ userRolesData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchUserAreas() {
  try {
    const { data } = yield call(api.get, {
      route: `userArea/getuserareas`,
    });
    const userAreasData = data;
    yield put(Actions.setUserAreas({ userAreasData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchUserRoleDetails() {
  try {
    yield put(Actions.setUserRoleDetailsLoaderStatus({ UserRoleDetailsLoader: true }));
    const { data } = yield call(api.get, {
      route: `userArea/GetUserRoleDetails`,
    });
    const userRoleDetailsData = data;
    yield put(Actions.setUserRoleDetails({ userRoleDetailsData }));
    yield put(Actions.setUserRoleDetailsLoaderStatus({ UserRoleDetailsLoader: false }));
  } catch (err) {
    notification('error', err, '');
    yield put(Actions.setUserRoleDetailsLoaderStatus({ UserRoleDetailsLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* fetchUserNotifications({ notificationSettingsParams }) {
  try {
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: true }));
    const { data } = yield call(api.get, {
      route: `notification/GetUserNotifications/` + notificationSettingsParams.userId,
    });
    const notificationSettingsData = data;
    yield put(Actions.setUserNotifications({ notificationSettingsData }));
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
  } catch (err) {
    notification('error', err, '');
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* addUserRole({ userRole }) {
  try {
    yield call(api.post, {
      route: `roles`,
      data: userRole,
    });
    yield put(Actions.fetchUserAreas());
    yield put(Actions.fetchUserRoles());
    yield put(Actions.fetchUserRoleDetails());
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* updateUserAreaRoles({ userAreaRoles }) {
  try {
    yield put(Actions.setUserRoleDetailsLoaderStatus({ UserRoleDetailsLoader: true }));
    yield call(api.put, {
      route: `UserArea/updateuserarearoles`,
      data: userAreaRoles,
    });
    yield put(Actions.fetchUserAreas());
    yield put(Actions.fetchUserRoles());
    yield put(Actions.fetchUserRoleDetails());
  } catch (err) {
    notification('error', err, '');
    yield put(Actions.setUserRoleDetailsLoaderStatus({ UserRoleDetailsLoader: false }));
    console.warn(err); // Handle exception
  }
}
function* addNotificationSetting({ addSettingModal }) {
  try {
    yield call(api.put, {
      route: `notification/AddSetting`,
      data: addSettingModal,
    });
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* addNotificationPreference({ addPreferenceModal, notificationSettingsParams }) {
  try {
    yield call(api.put, {
      route: `notification/AddPreference`,
      data: addPreferenceModal,
    });
    yield put(Actions.fetchUserNotifications({ notificationSettingsParams }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAppNotifications({ userId }) {
  try {
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: true }));
    const { data } = yield call(api.get, {
      route: `Notification/GetNotifications/` + userId,
    });
    const appNotifications = data;
    yield put(Actions.setAppNotifications({ appNotifications }));
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
  } catch (err) {
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* dismissAppNotifications({ id, comment }) {
  try {
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: true }));
    yield call(api.put, {
      route: `Notification/DismissNotification/${id}/${comment}`,
    });
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
  } catch (err) {
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* dismissAllAppNotifications({ comment }) {
  try {
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: true }));
    yield call(api.put, {
      route: `Notification/DismissAllNotification/${comment}`,
    });
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
  } catch (err) {
    yield put(Actions.setUserNotificationsLoaderStatus({ notificationSettingsLoader: false }));
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_AUTHORIZED_USERS, fetchAuthorizedUsers),
    takeLatest(ActionTypes.FETCH_USER_ROLES, fetchUserRoles),
    takeLatest(ActionTypes.UPDATE_USER_ROLE, updateUserRole),
    takeLatest(ActionTypes.FETCH_USER_ROLE_DETAILS, fetchUserRoleDetails),
    takeLatest(ActionTypes.FETCH_USER_AREAS, fetchUserAreas),
    takeLatest(ActionTypes.FETCH_USER_NOTIFICATIONS, fetchUserNotifications),
    takeLatest(ActionTypes.ADD_NOTIFICATION_SETTING, addNotificationSetting),
    takeLatest(ActionTypes.ADD_NOTIFICATION_PREFERENCE, addNotificationPreference),
    takeLatest(ActionTypes.ADD_USER_ROLE, addUserRole),
    takeLatest(ActionTypes.UPDATE_USER_AREA_ROLES, updateUserAreaRoles),
    takeLatest(ActionTypes.UPDATE_USER_CONTACT_DATA, updateUserContactData),
    takeLatest(ActionTypes.FETCH_APP_NOTIFICATIONS, fetchAppNotifications),
    takeLatest(ActionTypes.DISMISS_APP_NOTIFICATIONS, dismissAppNotifications),
    takeLatest(ActionTypes.DISMISS_ALL_APP_NOTIFICATIONS, dismissAllAppNotifications),
  ]);
}
